import "/www/app/root.css?transform-only";export default "__VITE_CSS_URL__2f7777772f6170702f726f6f742e6373733f7472616e73666f726d2d6f6e6c79__"